export default __webpack_public_path__ + "static/media/question.e016cac9.svg";